import { calendarConstants as cc } from 'srcReact/CalendarPage/constant'
import { calendarService } from 'srcReact/services'

export const calendarActions = {
  getCalendarEvents,
  setSelectedEvent,
  setSelectedTab,
  updateRSVPData
}

function getCalendarEvents(payload) {
  return (dispatch) => {
    dispatch(request())

    calendarService.getCalendarEvents(payload).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request() {
    return { type: cc.GET_CALENDAR_EVENTS_REQUEST }
  }
  function success(response) {
    return { type: cc.GET_CALENDAR_EVENTS_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_CALENDAR_EVENTS_FAILURE, error }
  }
}

function updateRSVPData(mixrId, rsvpData) {
  return { type: cc.UPDATE_RSVP_DATA, mixrId, rsvpData }
}

function setSelectedEvent(event) {
  return {
    type: cc.SET_SELECTED_EVENT,
    event
  }
}

function setSelectedTab(tab) {
  return {
    type: cc.SET_SELECTED_TAB,
    tab
  }
}
